import {Account} from "./account";

export class Freighter {
  id: number;
  name: string;
  own_tariffs: boolean;
  account: Account;
}
